import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { TargetIcon, DollarSignIcon, GraduationCapIcon, LockIcon, ScaleIcon, UsersIcon, CheckIcon } from 'lucide-react';
import { JobsSection } from '../components/JobsSection';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function CareersPage() {
  return <div className="w-full" data-id="element-843" data-mp="1mdjh3f0xeued">
      {/* HERO SECTION */}
      <section className="section-navy hero-grid-pattern" data-id="element-844" data-mp="1hh2p29qlvvw0">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-845" data-mp="1hinjlzcx7etv">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} data-id="element-846" data-mp="1wbhd4op11vhj">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight max-w-4xl mx-auto text-white" data-id="element-847" data-mp="1rf0e2zgahwpo">
              Build Your Career with New River Systems
            </h1>
            <div className="h-1.5 w-24 bg-nrs-orange mx-auto rounded-full mb-6" data-id="element-848" data-mp="3t6vn17b5vn47"></div>
            <p className="text-xl text-nrs-light mb-4 max-w-3xl mx-auto" data-id="element-849" data-mp="2xbyir0ne8j5u">
              Join a team of cleared professionals delivering mission-critical
              solutions to federal government and enterprise clients
            </p>
          </motion.div>
        </div>
      </section>

      {/* WHY WORK AT NRS */}
      <section className="section-white" data-id="element-850" data-mp="3b3v7cupusaxh">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-851" data-mp="3b4o9fidvac9a">
          <h2 className="text-3xl font-bold text-center mb-4" data-id="element-852" data-mp="3g1el7tin2low">
            Why Work at New River Systems?
          </h2>
          <div className="h-1 w-16 bg-nrs-orange mx-auto rounded-full mb-12" data-id="element-853" data-mp="3l33xtdlif7f3"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-854" data-mp="3p3e4ksh4m1v0">
            <div className="card text-center flex flex-col items-center" data-id="element-855" data-mp="3u0eejeh3jore">
              <TargetIcon className="h-10 w-10 text-nrs-orange mb-4" data-id="element-856" data-mp="1upd8uggvhuz5" />
              <h3 className="text-xl font-bold mb-3" data-id="element-857" data-mp="1znojgtezs9if">Meaningful Work</h3>
              <p className="text-nrs-gray" data-id="element-858" data-mp="1znwsga7zuuoc">
                Support critical federal missions that matter
              </p>
            </div>
            <div className="card text-center flex flex-col items-center" data-id="element-859" data-mp="2y00syopwnjnm">
              <DollarSignIcon className="h-10 w-10 text-nrs-orange mb-4" data-id="element-860" data-mp="2y1u2cbrwkhzb" />
              <h3 className="text-xl font-bold mb-3" data-id="element-861" data-mp="3c0jxvmz2q9lk">
                Competitive Compensation
              </h3>
              <p className="text-nrs-gray" data-id="element-862" data-mp="372a3vfp35f1j">
                Salary, bonuses, and comprehensive benefits
              </p>
            </div>
            <div className="card text-center flex flex-col items-center" data-id="element-863" data-mp="3gyv9o38xiu6f">
              <GraduationCapIcon className="h-10 w-10 text-nrs-orange mb-4" data-id="element-864" data-mp="3upqk3jz2tjc4" />
              <h3 className="text-xl font-bold mb-3" data-id="element-865" data-mp="3urum1wdf089r">
                Professional Development
              </h3>
              <p className="text-nrs-gray" data-id="element-866" data-mp="3qqivnompvj0i">
                Training budget, certifications, and career growth
              </p>
            </div>
            <div className="card text-center flex flex-col items-center" data-id="element-867" data-mp="3ki2jap27iqo">
              <LockIcon className="h-10 w-10 text-nrs-orange mb-4" data-id="element-868" data-mp="n4pdb9kswn88" />
              <h3 className="text-xl font-bold mb-3" data-id="element-869" data-mp="n3e9xav9phhn">Clearance Sponsorship</h3>
              <p className="text-nrs-gray" data-id="element-870" data-mp="s3k694chfs62">We sponsor security clearances</p>
            </div>
            <div className="card text-center flex flex-col items-center" data-id="element-871" data-mp="d6jberyzvh3d">
              <ScaleIcon className="h-10 w-10 text-nrs-orange mb-4" data-id="element-872" data-mp="i54dkwxt4aug" />
              <h3 className="text-xl font-bold mb-3" data-id="element-873" data-mp="4f0yqr19bjf1">Work-Life Balance</h3>
              <p className="text-nrs-gray" data-id="element-874" data-mp="4co9dst666ry">
                Remote/hybrid options and generous PTO
              </p>
            </div>
            <div className="card text-center flex flex-col items-center" data-id="element-875" data-mp="3qmhbj5pj63ev">
              <UsersIcon className="h-10 w-10 text-nrs-orange mb-4" data-id="element-876" data-mp="3qk4my9p9ousu" />
              <h3 className="text-xl font-bold mb-3" data-id="element-877" data-mp="3vlbse23xthwc">Collaborative Culture</h3>
              <p className="text-nrs-gray" data-id="element-878" data-mp="3hmkheokdgccf">
                Work with talented, mission-focused professionals
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* EMPLOYEE BENEFITS */}
      <section className="section-light-blue" data-id="element-879" data-mp="3eiwicr5dxz4s">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-880" data-mp="39k1qkzpfx08j">
          <h2 className="text-3xl font-bold text-center mb-4" data-id="element-881" data-mp="39mxpord0xuyk">
            Employee Benefits
          </h2>
          <div className="h-1 w-16 bg-nrs-orange mx-auto rounded-full mb-6" data-id="element-882" data-mp="2zurwjeb1d7hs"></div>
          <p className="text-center text-lg text-nrs-gray mb-10" data-id="element-883" data-mp="2zspa1493dwht">
            New River Systems is proud to provide the following employee
            benefits:
          </p>

          <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-884" data-mp="2qsipwziw1y9o">
            <div className="flex items-center gap-4 bg-white p-4 rounded-md shadow-sm" data-id="element-885" data-mp="2lvs9gb3690nq">
              <CheckIcon className="h-6 w-6 text-nrs-orange flex-shrink-0" data-id="element-886" data-mp="2gwz6vdpfau2c" />
              <span className="text-lg font-bold text-nrs-navy" data-id="element-887" data-mp="k3dxdsnb6qf8">
                Medical, Dental & Vision Insurance
              </span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-md shadow-sm" data-id="element-888" data-mp="f5casxqoc8z0">
              <CheckIcon className="h-6 w-6 text-nrs-orange flex-shrink-0" data-id="element-889" data-mp="nl1vg4yxiiw7" />
              <span className="text-lg font-bold text-nrs-navy" data-id="element-890" data-mp="rm3kjsz4tekg">
                Short-term and Long-term Disability
              </span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-md shadow-sm" data-id="element-891" data-mp="wg7v0m7lw4qa">
              <CheckIcon className="h-6 w-6 text-nrs-orange flex-shrink-0" data-id="element-892" data-mp="11f2ja3ocelhs" />
              <span className="text-lg font-bold text-nrs-navy" data-id="element-893" data-mp="4oa5xdssn7jp">
                Basic Term Life Insurance
              </span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-md shadow-sm" data-id="element-894" data-mp="dnnf05d09u3w">
              <CheckIcon className="h-6 w-6 text-nrs-orange flex-shrink-0" data-id="element-895" data-mp="imgu227xxt66" />
              <span className="text-lg font-bold text-nrs-navy" data-id="element-896" data-mp="inrv3ua04mtl">
                401(k) Plan with Profit Sharing
              </span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-md shadow-sm" data-id="element-897" data-mp="1u0uesy7edshz">
              <CheckIcon className="h-6 w-6 text-nrs-orange flex-shrink-0" data-id="element-898" data-mp="14cyq1qi4onay" />
              <span className="text-lg font-bold text-nrs-navy" data-id="element-899" data-mp="14fb2xp9147h5">
                Paid Vacation & Holidays
              </span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-md shadow-sm" data-id="element-900" data-mp="1eamnio74c8wt">
              <CheckIcon className="h-6 w-6 text-nrs-orange flex-shrink-0" data-id="element-901" data-mp="19cbdodgtpyel" />
              <span className="text-lg font-bold text-nrs-navy" data-id="element-902" data-mp="lmqr7klgoj0k">
                Professional Development Budget
              </span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-md shadow-sm" data-id="element-903" data-mp="gpgvjn7hbb4a">
              <CheckIcon className="h-6 w-6 text-nrs-orange flex-shrink-0" data-id="element-904" data-mp="vdldgoypjim0" />
              <span className="text-lg font-bold text-nrs-navy" data-id="element-905" data-mp="qltlc9zwl4tr">
                Security Clearance Sponsorship
              </span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-md shadow-sm" data-id="element-906" data-mp="2uefw8cty7ea">
              <CheckIcon className="h-6 w-6 text-nrs-orange flex-shrink-0" data-id="element-907" data-mp="3u2jwt4e98a2u" />
              <span className="text-lg font-bold text-nrs-navy" data-id="element-908" data-mp="29jzm3js2g4tc">
                Tuition Reimbursement
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* CURRENT OPPORTUNITIES (live from WordPress job feed) */}
      <JobsSection data-id="element-909" data-mp="24loe7elc04dr" />

      {/* CTA */}
      <section className="section-navy" data-id="element-910" data-mp="24mpz0as5g58o">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-911" data-mp="24jllunwphz5v">
          <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-912" data-mp="2sc25v400817t">
            Ready to Join Our Team?
          </h3>
          <p className="text-lg text-nrs-light mb-8" data-id="element-913" data-mp="2x89ckz085gqt">
            Submit your resume to careers@newriversystems.com
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-914" data-mp="2nbweloxncgq9">
            <a href="mailto:careers@newriversystems.com" className="btn-primary bg-white text-nrs-navy hover:bg-nrs-light" data-id="element-915" data-mp="2ne0pwrxvki0k">
              Email Your Resume
            </a>
            <a href="mailto:careers@newriversystems.com" className="btn-secondary border-white text-white hover:bg-white/10 hover:text-white" data-id="element-916" data-mp="1bykbxhdmi45o">
              View Open Positions
            </a>
          </div>
        </div>
      </section>
    </div>;
}